/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { ActionButton, IButtonProps } from '@fluentui/react/lib/Button';
import { getStylist } from 'src/core/themes/luisStylist';

const { styleComponent } = getStylist('TestPaneTopAction');

type ActionPlacement = 'left' | 'right';

const getActionCssProperties = (placement: ActionPlacement, actionColor: string) =>
    placement === 'left'
        ? {
              padding: 4,
              $nest: {
                  '& .ms-Button-label': {
                      paddingLeft: 0,
                      marginLeft: 0
                  },
                  '&:not([disabled])': {
                      color: actionColor
                  }
              }
          }
        : {
              padding: 4,
              $nest: {
                  '& .ms-Button-label': {
                      paddingRight: 0,
                      marginRight: 0
                  },
                  '&:not([disabled])': {
                      color: actionColor
                  }
              }
          };

export const getTestPaneTopAction = (placement: ActionPlacement, mode: 'light' | 'dark' = 'light') =>
    styleComponent<IButtonProps>(ActionButton)('Action', theme => ({
        height: 'auto',
        fontSize: theme.actionFontSize,
        ...getActionCssProperties(placement, mode === 'light' ? theme.actionColorLight : theme.actionColorDark)
    }));
